export default __webpack_public_path__ + "static/media/3.f85cf05a.png";